import { dispatch } from 'store';
import { openSnackbar } from 'store/reducers/snackbar';

/**
 * Yellow (warning) snackbar shown whenever a client-side send is suppressed by
 * the config/notificationSettings.captureNotifications flag. Keeps a forgotten
 * flag visible instead of silently swallowing sends.
 */
export default function notifyCaptureSuppressed(
  what: 'Notification' | 'Email' | 'Text' = 'Notification'
) {
  dispatch(
    openSnackbar({
      open: true,
      message: `${what} not sent: Dev mode active`,
      variant: 'alert',
      alert: { color: 'warning' },
      close: false
    })
  );
}
